/* SALITRE — product.js: selector de variantes */
(function () {
  'use strict';

  const section = document.querySelector('[data-product-section]');
  if (!section) return;

  const jsonEl = section.querySelector('[data-product-json]');
  if (!jsonEl) return;
  const product = JSON.parse(jsonEl.textContent);

  const form = section.querySelector('[data-product-form]');
  const idInput = section.querySelector('[data-variant-id]');
  const addBtn = section.querySelector('[data-add-to-cart]');
  const pickers = section.querySelectorAll('.variant-picker');

  const persInput = section.querySelector('[data-personalization-input]');
  const persCount = section.querySelector('[data-personalization-count]');
  if (persInput && persCount) {
    const updateCount = () => { persCount.textContent = persInput.value.length; };
    persInput.addEventListener('input', updateCount);
    updateCount();
  }

  if (!form || !idInput || pickers.length === 0) return;

  function selectedOptions() {
    return Array.from(pickers).map((picker) => {
      const checked = picker.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  }

  function findVariant(options) {
    return product.variants.find((v) => v.options.every((opt, i) => opt === options[i]));
  }

  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return value + ' €';
  }

  function update() {
    const variant = findVariant(selectedOptions());
    if (!variant) {
      addBtn.disabled = true;
      addBtn.textContent = window.theme.strings.unavailable;
      return;
    }
    idInput.value = variant.id;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());

    if (variant.available) {
      addBtn.disabled = false;
      addBtn.innerHTML = window.theme.strings.addToCart + ' &mdash; <span data-price>' + formatMoney(variant.price) + '</span>';
    } else {
      addBtn.disabled = true;
      addBtn.textContent = window.theme.strings.soldOut;
    }
  }

  section.querySelectorAll('[data-option-input]').forEach((input) =>
    input.addEventListener('change', update)
  );
})();
